<div class="content-block">
    <div class="dx-card responsive-paddings">

        <div class="content-grid">
            <h2 class="content-block">Card balance transactions </h2>

            <!-- <dx-data-grid class="dx-card wide-card" [dataSource]="dataSource" [showBorders]="false" [focusedRowEnabled]="true"
                [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true">
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxi-column dataField="Card.Merchant.CompanyName" caption="Merchant"> </dxi-column>
                <dxi-column dataField="Card.CardNumber" caption="Card number"> </dxi-column>
                <dxi-column dataField="Balance" caption="Balance"> </dxi-column>
                <dxi-column dataField="Created" caption="Created"> </dxi-column>
                <dxi-column dataField="Status" caption="Status"> </dxi-column>
            </dx-data-grid> -->
        </div>

</div></div>